// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile =  {
    Auth: {        
        // REQUIRED - Amazon Cognito Region
        region: 'ap-south-1',
        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: 'ap-south-1_2Yka6ry40',
        userPoolWebClientId: '2jked2im3ch8scc53gjjs5rvss',
        // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
        mandatorySignIn: false,
    },
    "aws_appsync_graphqlEndpoint": "https://t4thzfxynnd33o4lnclzivsqzu.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "null",
};

export default awsmobile;